module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_03@3x-168ca2bc59d09aae8c3f8c5fda5cde18.webp";